"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendly = void 0;
var base = 'https://calendly.com/feather-insurance';
var baseEu = 'https://calendly.com/feather-eu';
var baseFrance = 'https://calendly.com/feather-france';
exports.calendly = {
    base: base,
    baseFrance: baseFrance,
    baseEu: baseEu,
    nonEUSelfEmployed: "".concat(base, "/non_eu_self_employed"),
    nonEUOtherChat: "".concat(base, "/non_eu_other"),
    accountHelp: "".concat(base, "/customer_help"),
    genericHelp: "".concat(base, "/insurance-expert-help"),
    expatHealthHelp: "".concat(base, "/expat-health-insurance"),
    dentalInsuranceAdvice: "".concat(base, "/dental-insurance-advice"),
    healthInsuranceAdvice: "".concat(base, "/health-insurance-advice"),
    healthInsuranceAdviceFamily: "".concat(base, "/health-insurance-advice-family"),
    healthInsuranceAdvicePriority: "".concat(base, "/health-insurance-advice-priority"),
    lifeInsurance: "".concat(base, "/life-insurance-sign-up"),
    customerSupport: "".concat(base, "/customer-support"),
    liabilityInsurance: "".concat(base, "/liability"),
    legalInsuranceAdvide: "".concat(base, "/legal-insurance-advice"),
    householdContents: "".concat(base, "/household-contents"),
    bikeInsurance: "".concat(base, "/bike-insurance"),
    disabilityInsurance: "".concat(base, "/occupational-disability"),
    dogLiabilityInsurance: "".concat(base, "/dog-liability-insurance"),
    petHealthInsurance: "".concat(base, "/pet-health"),
    expatInsuranceEu: "".concat(baseEu, "/expat-health-insurance"),
    genericHelpFrance: "".concat(baseFrance, "/customer-support"),
    pensionInsurance: "".concat(base, "/pension-insurance"),
};
